import types from '../mutation-types'

const state = {
  nodes: [],
  singleNode: {}
}

const getters = {
  getNodes: (state) => {
    return state.nodes
  },
  getSingleNode: (state) => {
    return state.singleNode
  }
}

const actions = {
  saveNodes({commit, state}, nodes) {
    commit(types.NODES, nodes)
  },
  saveSingleNode({commit, state}, singleNode) {
    commit(types.SINGLE_NODE, singleNode)
  }
}

const mutations = {
  [types.NODES](state, nodes) {
    state.nodes = null
    state.nodes = nodes
  },
  [types.SINGLE_NODE](state, singleNode) {
    state.singleNode = null
    state.singleNode = singleNode
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tree.js